import type { TourStats } from "../../shared/api-types";

export type DayPoint = { date: string; views: number; visitors: number };

/** Lücken im Tagesverlauf mit 0 auffüllen (der Server liefert nur Tage mit Aufrufen). */
export function fillDaily(stats: TourStats, now = Date.now()): DayPoint[] {
  const byDate = new Map(stats.daily.map((d) => [d.date, d]));
  const out: DayPoint[] = [];
  for (let i = stats.days - 1; i >= 0; i--) {
    const date = new Date(now - i * 86_400_000).toISOString().slice(0, 10);
    const d = byDate.get(date);
    out.push({ date, views: d?.views ?? 0, visitors: d?.visitors ?? 0 });
  }
  return out;
}

/** Anteil in Prozent, 0 bei leerem Nenner. */
export function pct(part: number, total: number): number {
  return total > 0 ? Math.round((part / total) * 100) : 0;
}

export type TrendPoint = DayPoint & { endDate: string; span: number };

/**
 * Lange Zeiträume („gesamte Zeit“) zu gleich großen Blöcken bündeln, damit die Balken
 * sichtbar bleiben. Gebündelt wird vom Ende her — der letzte Block endet auf heute.
 */
export function groupDaily(points: DayPoint[], maxBars = 120): TrendPoint[] {
  const span = Math.max(1, Math.ceil(points.length / maxBars));
  if (span === 1) return points.map((p) => ({ ...p, endDate: p.date, span: 1 }));
  const out: TrendPoint[] = [];
  for (let end = points.length; end > 0; end -= span) {
    const chunk = points.slice(Math.max(0, end - span), end);
    out.unshift({
      date: chunk[0]!.date,
      endDate: chunk[chunk.length - 1]!.date,
      span: chunk.length,
      views: chunk.reduce((n, p) => n + p.views, 0),
      visitors: chunk.reduce((n, p) => n + p.visitors, 0),
    });
  }
  return out;
}

/**
 * Abstand der Datums-Marken in Balken: möglichst Wochenraster, aber nie mehr als
 * 13 Beschriftungen — sonst überlappen sie.
 */
export function tickStep(count: number, spanDays: number): number {
  const candidates = [1, 7, 14, 28, 56, 91, 182, 364];
  for (const days of candidates) {
    const step = Math.max(1, Math.round(days / spanDays));
    if (count / step <= 13) return step;
  }
  return count;
}
